import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 12.0354L9 18.0354L21 6.0354", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheckLarge);
const Memo = memo(ForwardRef);
export default Memo;
